import React from "react";
import { NavBar } from "./NavBar";
import thumbs from "../../assets/img/thumbs.png";
import poweredBy from "../../assets/img/powered-by.jpg";

export const Header = () => {
  return (
    <>
      <div className='d-flex align-items-center w-100 mb-2'>
        <div>
          <img src={thumbs} className='img-fluid' style={{ width: "60px" }} alt='...' />
        </div>
        <div className='ms-3 fw-bold opacity-50' style={{ fontSize: "2.5rem" }}>
          Speed Test BETA
        </div>
        <div className='ms-auto'>
          <img src={poweredBy} className='img-fluid' alt='...' />
        </div>
      </div>
      <div className='container p-0 m-0'>
        <NavBar></NavBar>
      </div>
    </>
  );
};
